/**
 * @class {RoadgamesEvent.Registration}
 * @extends {RoadgamesEvent.Base}
 * @param {DR.events.struct.Event} event
 * @param {DR.events.struct.Stats} stats
 * @param {DR.top.GetTop} top
 */
RoadgamesEvent.Registration = Class(
	{
		/**
		 * @lends {RoadgamesEvent.Registration#}
		 */
		__NAME: 'RoadgamesEvent.Registration',

		state: 'registration',

		_draw() {
			this._drawWelcome();
			this._drawTopSponsors();
			this._drawInfoBlock();
			this._drawApiGallery();
			this._drawTasksSlider();
			this._drawSteps();
			this._drawPrizeSponsors();
			this._drawInstagramFeed();
			this._drawTestimonials();
			this._drawExperience();
			this._drawGiftCards();
			this._drawCta();
		},

		_drawWelcomeBottom() {
			if( this.event.hasTeam ) {
				return mkE({
					tag: 'div',
					className: 'single-event-welcome-purchase',
					els: [
						{
							tag: 'a',
							href: D.url('/profile/event/' + this.event.seoTitle),
							className: 'button button-turquoise',
							text: D.Lang.get('event.myTeam')
						}
					]
				});
			}
			if( this.event.settings.isFreeGame ) {
				return mkE({
					tag: 'div',
					className: 'single-event-welcome-purchase',
					els: [
						{
							tag: 'div',
							className: 'button-container',
							els: [
								this._buyBtn = mkE({
									tag: 'a',
									href: D.url(D.Lang.get('home.welcome.button.link')),
									className: 'button button-pink',
									text: D.Lang.get('home.welcome.button')
								})
							]
						},
						{
							tag: 'div',
							className: 'price-container',
							els: [
								{
									tag: 'div',
									className: 'price',
									text: D.Lang.get('event.freeGame')
								}
							]
						}
					]
				});
			}
			let activePriceIndex = this.event.ticket.prices.findIndex(price => price.isActive);
			if( activePriceIndex === -1 ) {
				return '';
			}
			let currentPrice = Object.assign({}, this.event.ticket.prices[activePriceIndex]);
			let nextPrice = null;
			if( this.event.ticket.prices[activePriceIndex + 1] ) {
				nextPrice = Object.assign({}, this.event.ticket.prices[activePriceIndex + 1]);
			}

			let purchaseLink = '/profile/event/' + this.event.seoTitle + '/create';
			if( !D.ID ) {
				purchaseLink = '/sign-in?redirect=' + encodeURIComponent(purchaseLink);
			}

			if( this.event.settings.ticketPerPerson ) {
				currentPrice.price *= this.event.minPlayers;
				if( nextPrice ) {
					nextPrice.price *= this.event.minPlayers;
				}
			}

			let discountAmount = D.SESSION_DISCOUNT_AMOUNT;
			let data = this.discountData;
			if( this.event.ticket.hasFirstAffiliateDiscount ) {
				data = this.event.ticket.firstAffiliateDiscount;
			} else if( this.event.ticket.hasAffiliateDiscount ) {
				data = this.event.ticket.affiliateDiscount;
			}
			if( data ) {
				switch( data.type ) {
					case 'static':
						discountAmount = data.amount;
						break;
					case 'percent':
						discountAmount = currentPrice.price * data.amount / 100;
						break;
				}
			}
			return mkE({
				tag: 'div',
				className: 'single-event-welcome-purchase',
				els: [
					{
						tag: 'div',
						className: 'button-container',
						els: [
							this._buyBtn = mkE({
								tag: 'a',
								href: D.url(purchaseLink),
								className: 'button button-pink',
								text: D.Lang.get('event.purchaseTicket')
							})
						]
					},
					{
						tag: 'div',
						className: 'price-container',
						els: [
							nextPrice || discountAmount ? {
								tag: 'div',
								className: 'next-price',
								text: '€' + ((nextPrice ? nextPrice.price : currentPrice.price) / 100).toFixed(2)
							} : null,
							{
								tag: 'div',
								className: 'price',
								text: '€' + ((currentPrice.price - discountAmount) / 100).toFixed(2)
							}
						]
					}
				]
			});
		},

		_drawCta() {
			if( this.event.hasTeam ) {
				return;
			}
			let className = 'single-event-cta';
			let els;
			let activePriceIndex = this.event.ticket.prices.findIndex(price => price.isActive);
			if( activePriceIndex === -1 ) {
				els = [
					{
						tag: 'div',
						className: 'button-container',
						els: [
							{
								tag: 'a',
								href: D.url(D.Lang.get('home.welcome.button.link')),
								className: 'button button-pink',
								text: D.Lang.get('home.welcome.button')
							}
						]
					},
					{
						tag: 'div',
						className: 'price-container',
						els: [
							{
								tag: 'div',
								className: 'price price-free',
								text: D.Lang.get('event.freeGame')
							}
						]
					}
				];
			} else {
				let currentPrice = Object.assign({}, this.event.ticket.prices[activePriceIndex]);
				let nextPrice = null;
				if( this.event.ticket.prices[activePriceIndex + 1] ) {
					nextPrice = Object.assign({}, this.event.ticket.prices[activePriceIndex + 1]);
				}

				let purchaseLink = '/profile/event/' + this.event.seoTitle + '/create';
				if( !D.ID ) {
					purchaseLink = '/sign-in?redirect=' + encodeURIComponent(purchaseLink);
				}

				if( this.event.settings.ticketPerPerson ) {
					currentPrice.price *= this.event.minPlayers;
					if( nextPrice ) {
						nextPrice.price *= this.event.minPlayers;
					}
				}

				let discountAmount = D.SESSION_DISCOUNT_AMOUNT;
				let data = this.discountData;
				if( this.event.ticket.hasFirstAffiliateDiscount ) {
					data = this.event.ticket.firstAffiliateDiscount;
				} else if( this.event.ticket.hasAffiliateDiscount ) {
					data = this.event.ticket.affiliateDiscount;
				}
				if( data ) {
					switch( data.type ) {
						case 'static':
							discountAmount = data.amount;
							break;
						case 'percent':
							discountAmount = currentPrice.price * data.amount / 100;
							break;
					}
				}

				let remainingInfo = null;
				if( currentPrice.priceType === 'date' && nextPrice ) {
					let time = currentPrice.priceChange;
					let seconds = Math.max(0, time - D.TIME);
					let days = Math.ceil(seconds / 86400);
					if( nextPrice ) {
						remainingInfo = D.Lang.nget(days, 'event.cta.block.days').replace('%DAYS%', days);
					} else {
						remainingInfo = D.Lang.nget(days, 'event.cta.block.end').replace('%DAYS%', days);
					}
				}
				const price = currentPrice.price - discountAmount;
				className += remainingInfo ? ' w-remaining' : '';
				els = [
					{
						tag: 'div',
						className: 'button-container',
						els: [
							{
								tag: 'a',
								href: D.url(purchaseLink),
								className: 'button button-pink',
								text: price > 0 ? D.Lang.get('event.purchaseTicket') : D.Lang.get('event.cta.freeTicket')
							}
						]
					},
					{
						tag: 'div',
						className: 'price-container',
						els: [
							nextPrice || discountAmount ? {
								tag: 'div',
								className: 'next-price',
								text: '€' + ((nextPrice ? nextPrice.price : currentPrice.price) / 100).toFixed(2)
							} : null,
							{
								tag: 'div',
								className: 'price',
								text: '€' + (price / 100).toFixed(2)
							}
						]
					},
					remainingInfo ? {
						tag: 'div',
						className: 'remaining',
						innerHTML: remainingInfo
					} : null
				];
			}
			this._cta = new T.CallToAction({
				className: className,
				els: els
			}).append(document.body);
		},

		onScroll() {
			if( this._cta && this._buyBtn ) {
				if( screen.width < 720 || this._buyBtn.offsetTop + 200 < window.scrollY ) {
					if( !this._cta.active ) {
						this._cta.show();
					}
				} else if( this._cta.active ) {
					this._cta.hide();
				}
			}
		},

		onShow() {
			PARENT.onShow();
			this.onScroll();
		},

		onLeave() {
			PARENT.onLeave();
			if( this._cta ) {
				this._cta.remove();
				this._cta = null;
			}
		}
	},
	RoadgamesEvent.Base
);

/**
 * @class {RoadgamesEvent.Registration.Race}
 * @extends {RoadgamesEvent.Registration}
 * @param {DR.events.struct.Event} event
 * @param {DR.events.struct.Stats} stats
 * @param {DR.top.GetTop} top
 */
RoadgamesEvent.Registration.Race = Class(
	{
		/**
		 * @lends {RoadgamesEvent.Registration.Race#}
		 */
		__NAME: 'RoadgamesEvent.Registration.Race',

		state: 'registration',

		/** @type {DR.events.struct.Event} */
		event: null,

		_draw() {
			this._drawWelcome();
			this._drawTopSponsors();
			this._drawInfoBlock();
			this._drawTasksSlider();
			this._drawSteps();
			this._drawPrizeSponsors();
			this._drawLiveAwards();
			this._drawApiGallery();
			this._drawExperience();
			this._drawTestimonials();
			this._drawInstagramFeed();
			this._drawGiftCards();
			this._drawCta();
		},

		onShow() {
			PARENT.onShow();
			if( this._prizeSpoonsorsSlider ) {
				this._prizeSpoonsorsSlider.onShow();
			}
		}
	},
	RoadgamesEvent.Registration
);